import * as React from 'react';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import styled from 'styled-components';

type ResultsPagingStatusProps = {
    readonly formatNumber: Function;
    readonly page: number;
    readonly pageSize: number;
    testid?: string;
    readonly totalRecords: number;
};

export const makeNumbers = (page: number, pageSize: number, totalRecords: number) => {
    const firstNumber = page === 1 ? 1 : pageSize * (page - 1) + 1;
    const secondNumber = totalRecords < pageSize ? totalRecords : pageSize * page;
    return {
        firstNumber,
        secondNumber: secondNumber > totalRecords ? totalRecords : secondNumber,
    };
};

const ResultsPagingStatus = ({
    formatNumber = (num: number) => num,
    page,
    pageSize,
    testid = 'messengerResultsPagingStatus',
    totalRecords,
}: ResultsPagingStatusProps) => {
    const { firstNumber, secondNumber } = makeNumbers(page, pageSize, totalRecords);
    if (!firstNumber || !secondNumber || !totalRecords) {
        return null;
    }
    const text =
        firstNumber === secondNumber
            ? `${formatNumber(firstNumber)} of ${formatNumber(totalRecords)}`
            : `${formatNumber(firstNumber)}-${formatNumber(secondNumber)} of ${formatNumber(totalRecords)}`;
    return (
        <StyledResultsPagingStatus data-testid={testid}>
            <BodySecondary color="secondary">{text}</BodySecondary>
        </StyledResultsPagingStatus>
    );
};

export default React.memo<ResultsPagingStatusProps>(ResultsPagingStatus);

const StyledResultsPagingStatus = styled.div`
    text-transform: lowercase;
`;
